// Constants
import {containerShipmentTypes} from '../types';
import {ContainerShipmentActionType} from '../../../types/containerShipmentTypes';


const initialState = {
  params: {
    shipmentStateParams: [],
    timeStateParams: []
  },
  containerShipmentResult: {
    count: 0,
    page: 1,
    size: 10,
    rows: []
  },
  containersInProcess: [],
  schedule: [],
  containerShipmentResultByDownloadDate: []
}

const containerShipmentReducer = (state = initialState, action: ContainerShipmentActionType) => {
  switch (action.type) {
    case containerShipmentTypes.GET_ALL_CONTAINER_SHIPMENTS:
      return {
        ...state,
        containerShipmentResult: action.containerShipmentResult
      };
    case containerShipmentTypes.GET_ALL_CONTAINERS_IN_PROCESS:
      return {
        ...state,
        containersInProcess: action.containersInProcess
      };
    case containerShipmentTypes.GET_CONTAINER_SHIPMENT_PARAMS:
      return {
        ...state,
        params: action.params
      };
    case containerShipmentTypes.GET_CONTAINER_SHIPMENT_SCHEDULE:
      return {
        ...state,
        schedule: action.schedule ?? []
      };
     case containerShipmentTypes.GET_CONTAINER_SHIPMENT_BY_DOWNLOAD_DATE:
      return {
        ...state,
        containerShipmentResultByDownloadDate: action.containerShipmentResultByDownloadDate ?? []
      };
    default:
      return state;
  }
};

export default containerShipmentReducer;
